import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('moneyFormat', function (number, roundDigit = 2, sign = '$', removeZero = true) {
  const fixedNumber = roundDigit !== -1 ? number.toFixed(roundDigit) : number
  let res = fixedNumber.toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  if (removeZero) res = res.replace('.00', '')
  if (sign === '') return res
  else return `${sign} ${res}`
})

Vue.filter('numberSign', function (number, sign) {
  const res = number
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

  return  `${sign} ${res}`
})


Vue.filter('truncate', function (value, limit) {
  return value.toString()
    .substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})